// removed by extract-text-webpack-plugin
module.exports = {"content":"_33ieHMrHQ_JH7zPYg_QUSt","callScreen":"_2wYUDSGP9piJG0c-3EeXTh","endCallButton":"_7nBiz10tDynlaWoS3p41r"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7195bc40","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/rep-call/rep-call.less
// module id = 5HsV
// module chunks = 1